export function mapSupplierProductToInternalHuuray(product, options = {}) {
  const { defaultRetailPrice = '0', defaultWeightInGram = 0, timeStart = null, supplierID = 380 } = options

  const elementTitle = product.productName || ''
  const elementContent = product.productText || ''

  const discountPct = product.discountPct
  const markup = (100 / (100 - discountPct)) * 100 - 100
  const discountFactor = (100 - discountPct) / 100
  const basePrice = product.variations.length && product.variations[0].skus.length ? Number(product.variations[0].skus[0].size) * discountFactor : 0
  const internalVariations = (product.variations || []).flatMap(variation => {
    return (variation.skus || []).map(sku => {
      return {
        variationTitle: `${sku.webtext}kr`,
        variationUID: sku.sku,
        variationStock: 0,
        limitedStock: sku.availabilityRegional === null || sku.availabilityRegional < 40 ? true : false,
        externalStock: false,
        subscriptions: [],
        variationSize: '',
        variationColor: '',
        allowPreorder: false,
        preorderStock: null,
        poolOrder: 0,
        EAN: '',
        purchasePriceDelta: Number(sku.size) * discountFactor - basePrice
      }
    })
  })

  return {
    elementTitle,
    elementContent,
    productPrice: basePrice,
    retailPrice: defaultRetailPrice,
    productPriceAdjust: markup.toFixed(2),
    profitPercentage: null,
    productStatus: 'AVAILABLE',
    productWeightInGram: defaultWeightInGram,
    timeStart,
    timeEnd: null,
    stockAvailableDate: null,
    productStockLimit: 0,
    minCount: 1,
    categories: [{ CategoryID: 672 }],
    catalogs: [
      {
        CatalogID: '',
        productPrice: '',
        productPriceAdjust: '',
        sticky: false,
        stickyDuration: 1,
        enableDiscount: false,
        discountPrice: null,
        basisPrice: null
      }
    ],
    variations: internalVariations,
    manufacturer: 'Gavekort',
    SupplierID: supplierID,
    dropshipFreightPrice: null,
    enabledropship: 0,
    translations: [],
    images: [],
    video: ''
  }
}
